import { GridColDef } from '@mui/x-data-grid-pro';
import { useCommonDataGridSlotProps } from 'components/common/dataGrid/hooks/useCommonDataGridSlotProps';
import { CompanyDataGridRow } from './columns';

interface UseCompanyDataGridSlotPropsOptions {
  columns: GridColDef<CompanyDataGridRow>[];
}

export function useCompanyDataGridSlotProps({
  columns,
}: UseCompanyDataGridSlotPropsOptions) {
  return useCommonDataGridSlotProps({ columns });
}
